export function pagination(page, pageCount, thisContainer) {


    $(thisContainer + ' .js-pag-plus1').remove();
    $(thisContainer + ' .js-pag-plus2').remove();
    $(thisContainer + ' .js-pag-plus3').remove();
    $(thisContainer + ' .js-pag-minus1').remove();
    $(thisContainer + ' .js-pag-minus2').remove();
    $(thisContainer + ' .js-pag-minus3').remove();
    $(thisContainer + ' .js-pag-dots').remove();

    // Update page number
    $(thisContainer + ' .pag-current-page').text(page);

    $(thisContainer + ' .js-pagination').removeClass('hide');

    // Last page in pagination
    $(thisContainer + ' .pag-last-page').text(pageCount);

    if (  pageCount === 1  ) {
        $(thisContainer + ' .js-pagination').addClass('hide');
    }

    // First page
    if (  page === 1  ) {

        // Previous button
        $(thisContainer + ' .pag-previous-page').hide();

        // First Button
        $(thisContainer + ' .pag-first-page').addClass('selected');

        // Last button
        $(thisContainer + ' .pag-last-page').removeClass('selected');

        // Next button
        $(thisContainer + ' .pag-next-page').show();

        // Current page
        $(thisContainer + ' .pag-current-page').hide().removeClass('selected');


        // If page count is less than 3
        if ( pageCount <= 2 ) {

            
        } else if ( pageCount <= 3 ) {

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' 
            );

        } else if ( pageCount <= 4 ) {

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>'
            );

        } else if ( pageCount <= 5 ) {

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>'
            );

        } else { 

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
                '<span class="js-pag-dots lhs pagination-button">...</span>'
            );
        }
        
    // Last page
    } else if ( page === pageCount ) {

        // Previous button
        $(thisContainer + ' .pag-previous-page').show();

        // First Button
        $(thisContainer + ' .pag-first-page').removeClass('selected');

        // Last button
        $(thisContainer + ' .pag-last-page').addClass('selected');

        // Next button
        $(thisContainer + ' .pag-next-page').hide();

        // Current page
        $(thisContainer + ' .pag-current-page').hide().removeClass('selected');

        // If page count is less than 3
        if ( pageCount <= 2 ) {

            
        } else if ( pageCount <= 3 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>' 
            );

        } else if ( pageCount <= 4 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>' 
            );

        } else if ( pageCount <= 5 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );


        } else { 

            $(thisContainer + ' .pag-current-page').before(
                '<span class="js-pag-dots lhs pagination-button">...</span>' + 
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'		
            );
        }


    // If we are on 2nd page
    } else if( page === 2) {

        $(thisContainer + ' .js-pag-button').show().removeClass('selected');
        $(thisContainer + ' .pag-current-page').show().addClass('selected');

        // If the page count is 3
        if ( pageCount <= 3 ) {

        // If page count is 4
        } else if ( pageCount <= 4 ) {

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>'

            );

        } else if ( pageCount <= 5 ) {

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>'
            );

        } else if ( pageCount <= 6 ) {

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>'
            );

        } else { 

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
                '<span class="js-pag-dots lhs pagination-button">...</span>'
            );
        }


    // If we are on 3rd page
    } else if( page === 3) {

        $(thisContainer + ' .js-pag-button').show().removeClass('selected');
        $(thisContainer + ' .pag-current-page').show().addClass('selected');

        // If page count is 4
        if ( pageCount <= 4 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

        } else if ( pageCount <= 5 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>'
            );

        } else if ( pageCount <= 6 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>'
            );

        } else if ( pageCount <= 7 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>'
            );


        } else {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
                '<span class="js-pag-dots lhs pagination-button">...</span>'
            );
        }

    // If we are on 4th page
    } else if( page === 4) {

        $(thisContainer + ' .js-pag-button').show().removeClass('selected');
        $(thisContainer + ' .pag-current-page').show().addClass('selected');

        // If page count is 5
        if ( pageCount <= 5 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

        } else if ( pageCount <= 6 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );
            
            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>'
            );

        } else if ( pageCount <= 7 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>'
            );

        } else {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
                '<span class="js-pag-dots lhs pagination-button">...</span>'
            );
        }

        

    // If we are on 5th page
    } else if( page === 5) {

        $(thisContainer + ' .js-pag-button').show().removeClass('selected');
        $(thisContainer + ' .pag-current-page').show().addClass('selected');

        if ( pageCount <= 6 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

        } else if ( pageCount <= 7 ) {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>'
            );


        } else {

            $(thisContainer + ' .pag-current-page').before(
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
            );

            $(thisContainer + ' .pag-current-page').after(
                '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
                '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
                '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
                '<span class="js-pag-dots lhs pagination-button">...</span>'
            );

        }

    // If we are 2nd to last page
    } else if( page === (pageCount-1)) {

        $(thisContainer + ' .js-pag-button').show().removeClass('selected');
        $(thisContainer + ' .pag-current-page').show().addClass('selected');


        // If page count is less than 3
        if ( pageCount <= 3 ) {

        } else { 

            $(thisContainer + ' .pag-current-page').before(
                '<span class="js-pag-dots lhs pagination-button">...</span>' + 
                '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
                '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
                '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'	
            );
        }


    // If we are 3rd to last page
    } else if( page === (pageCount-2)) {

        $(thisContainer + ' .js-pag-button').show().removeClass('selected');
        $(thisContainer + ' .pag-current-page').show().addClass('selected');

        $(thisContainer + ' .pag-current-page').before(
            '<span class="js-pag-dots lhs pagination-button">...</span>' + 
            '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
            '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
            '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
        );

        $(thisContainer + ' .pag-current-page').after(
            '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>'
        );

    // If we are 4th to last page
    } else if( page === (pageCount-3)) {

        $(thisContainer + ' .js-pag-button').show().removeClass('selected');
        $(thisContainer + ' .pag-current-page').show().addClass('selected');

        $(thisContainer + ' .pag-current-page').before(
            '<span class="js-pag-dots lhs pagination-button">...</span>' + 
            '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
            '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
            '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
        );

        $(thisContainer + ' .pag-current-page').after(
            '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
            '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>'
        );


    // If we are 5th to last page
    } else if( page === (pageCount-4)) {

        $(thisContainer + ' .js-pag-button').show().removeClass('selected');
        $(thisContainer + ' .pag-current-page').show().addClass('selected');

        $(thisContainer + ' .pag-current-page').before(
            '<span class="js-pag-dots lhs pagination-button">...</span>' + 
            '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
            '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
            '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
        );

        $(thisContainer + ' .pag-current-page').after(
            '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
            '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
            '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>'
        );


    } else {


        $(thisContainer + ' .js-pag-button').show().removeClass('selected');
        $(thisContainer + ' .pag-current-page').show().addClass('selected');

        $(thisContainer + ' .pag-current-page').before(
            '<span class="js-pag-dots lhs pagination-button">...</span>' +
            '<a class="js-pag-button js-pag-minus3 lhs pagination-button" href="#">' + (page-3) + '</a>' +
            '<a class="js-pag-button js-pag-minus2 lhs pagination-button" href="#">' + (page-2) + '</a>' +
            '<a class="js-pag-button js-pag-minus1 lhs pagination-button" href="#">' + (page-1) + '</a>'
        );

        $(thisContainer + ' .pag-current-page').after(
            '<a class="js-pag-button js-pag-plus1 lhs pagination-button" href="#">' + (page+1) + '</a>' +
            '<a class="js-pag-button js-pag-plus2 lhs pagination-button" href="#">' + (page+2) + '</a>' +
            '<a class="js-pag-button js-pag-plus3 lhs pagination-button" href="#">' + (page+3) + '</a>' +
            '<span class="js-pag-dots lhs pagination-button">...</span>'
        );

    }
}